import $api from '@/services/api-service';

export default function(store) {
    $api.init();
    $api.setHeader();
    store.$api = $api;
}
